/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { apiClient } from '../client'

export interface Role {
  id: string
  dataId: string
  name: string
  description?: string | null
  createdAt: string
  updatedAt: string
}

export interface CreateRoleRequest {
  name: string
  description?: string
}

export interface UpdateRoleRequest {
  name?: string
  description?: string
}

/**
 * Získání seznamu rolí
 */
export const getRoles = async (): Promise<Role[]> => {
  const response = await apiClient.get<Role[]>('/api/roles')
  return response.data
}

/**
 * Získání detailu role
 */
export const getRole = async (id: string): Promise<Role> => {
  const response = await apiClient.get<Role>(`/api/roles/${id}`)
  return response.data
}

/**
 * Vytvoření nové role
 */
export const createRole = async (data: CreateRoleRequest): Promise<Role> => {
  const response = await apiClient.post<Role>('/api/roles', data)
  return response.data
}

/**
 * Aktualizace role
 */
export const updateRole = async (id: string, data: UpdateRoleRequest): Promise<Role> => {
  const response = await apiClient.patch<Role>(`/api/roles/${id}`, data)
  return response.data
}

/**
 * Smazání role
 */
export const deleteRole = async (id: string): Promise<void> => {
  await apiClient.delete(`/api/roles/${id}`)
}
